
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, watchEffect, nextTick } from 'vue'
import { DoubleRightOutlined, DownOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
import { init, ECharts, EChartsOption } from 'echarts'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import { Slider } from 'ant-design-vue'
import { radioProps } from 'ant-design-vue/lib/radio/Radio'
import HydwHeadline from '@/components/HydwHeadline.vue'
import Nodata from '@/components/page/nodata.vue'
const allList: any = {
  ybqy: {
    // 0
    PerShareIndexData: [
      {
        name: '每股收益_TTM',
        val: 'EarningsPerShareTTM'
      },
      {
        name: '每股净资产',
        val: 'NetAssetsPerShare'
      },
      {
        name: '每股现金流量净额_TTM',
        val: 'NetCashFlowPerShare'
      }
    ],
    ProfitabilityData: [
      {
        name: '净资产收益率',
        val: 'Roe'
      },
      {
        name: '净资产收益率_TTM',
        val: 'RoeTTM'
      },
      {
        name: '销售毛利率',
        val: 'GrossProfitMargin'
      },
      {
        name: '销售毛利率_TTM',
        val: 'GrossProfitMarginTTM'
      }
    ],
    GrowthAbilityData: [
      {
        name: '营业收入同比增长',
        val: 'GrowthInOperatingIncome'
      },
      {
        name: '净利润同比增长',
        val: 'GrowthInNetProfit'
      },
      {
        name: '每股现金流同比增长',
        val: 'CashFlowPerShareincreased'
      },
      {
        name: '净资产同比增长',
        val: 'GrowthInNetAssets'
      }
    ],
    OperatingCapacityData: [
      {
        name: '应收账款周转率',
        val: 'AccountsReceivableTurnoverRate'
      },
      {
        name: '总资产周转率',
        val: 'TurnoverRateOfTotalAssets'
      },
      {
        name: '应付账款周转率',
        val: 'AccountsPayableTurnoverRate'
      },
      {
        name: '总资产周转率_TTM',
        val: 'TurnoverRateOfTotalAssetsTTM'
      }
    ],
    ScaleComparisonData: [
      {
        name: '净利润',
        val: 'NetProfit'
      },
      {
        name: '扣非净利润',
        val: 'DeductionOfNonNetProfit'
      },
      {
        name: '营业总收入',
        val: 'TotalOperatingIncome'
      },
      {
        name: '总市值',
        val: 'TotalMarketCapitalization'
      },
      {
        name: '流通市值',
        val: 'CirculationMarketValue'
      }
    ]
  },
  jrqy: {
    PerShareIndexData: [
      {
        name: '每股收益_TTM',
        val: 'EarningsPerShareTTM'
      },
      {
        name: '每股净资产',
        val: 'NetAssetsPerShare'
      },
      {
        name: '每股现金流量净额_TTM',
        val: 'NetCashFlowPerShare'
      }
    ],
    ProfitabilityData: [
      {
        name: '净资产收益率',
        val: 'Roe'
      },
      {
        name: '净资产收益率_TTM',
        val: 'RoeTTM'
      },
      {
        name: '销售净利率',
        val: 'SalesMargin'
      }
    ],
    GrowthAbilityData: [
      {
        name: '营业收入同比增长',
        val: 'GrowthInOperatingIncome'
      },
      {
        name: '净利润同比增长',
        val: 'GrowthInNetProfit'
      },
      {
        name: '每股现金流同比增长',
        val: 'CashFlowPerShareincreased'
      },
      {
        name: '净资产同比增长',
        val: 'GrowthInNetAssets'
      }
    ],
    ScaleComparisonData: [
      {
        name: '净利润',
        val: 'NetProfit'
      },
      {
        name: '扣非净利润',
        val: 'DeductionOfNonNetProfit'
      },
      {
        name: '营业总收入',
        val: 'TotalOperatingIncome'
      },
      {
        name: '总市值',
        val: 'TotalMarketCapitalization'
      },
      {
        name: '流通市值',
        val: 'CirculationMarketValue'
      }
    ]
  }
}
const tags = [
  {
    value: 'PerShareIndexData',
    label: '每股指标',
    unit: '元'
  },
  {
    value: 'ProfitabilityData',
    label: '盈利能力',
    unit: '%'
  },
  {
    value: 'GrowthAbilityData',
    label: '成长能力',
    unit: '%'
  },
  {
    value: 'OperatingCapacityData',
    label: '营运能力',
    unit: '次'
  },
  {
    value: 'ScaleComparisonData',
    label: '规模比较',
    unit: '元'
  }
]
const baseColumns = [
  {
    title: '序',
    dataIndex: 'index',
    key: 'index',
    width: '50px',
    fixed: 'left',
    slots: { customRender: 'Index' }
  },
  {
    title: '代码',
    dataIndex: 'Inst',
    key: 'Inst',
    width: '80px',
    fixed: 'left'
  },
  {
    title: '名称',
    dataIndex: 'Name',
    key: 'Name',
    width: '120px',
    fixed: 'left',
    ellipsis: true,
    slots: { customRender: 'ellipsis' }
  }
]
export default defineComponent({
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, DownOutlined, HydwHeadline, Charts, Nodata },
  setup(props, context) {
    const mytable = ref()
    const pageData: any = reactive({
      industryLevel: 0, // 行业级别
      reportDate: '',
      reportDatas: [],
      defaultReportDate: null,
      activeKey: [],
      CompanyNumAndIndustryData: {},

      tags: [],
      activeTagVal: 'PerShareIndexData',
      list: [],
      activelist: 'EarningsPerShareTTM',

      FlagEnterpriseType: 0, // 0表示非金融，1表示金融企业

      unit: '元',
      columns: [],
      data: [],
      option: null,
      current: 1,
      pageSize: 10,
      pagination: {},
      total: 0,
      isShowTable: false,

      spinning: true,
      tableKey: 1,
      currIndustryComparisonData: {}
    })
    pageData.pagination = {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      showTotal: (total: any) => `共${total}条`,
      pageSizeOptions: ['10', '20', '50', '100'],
      showTitle: false,
      onChange: (current: any, pageSize: any) => {
        pageData.pagination.current = current
      },
      onShowSizeChange: (current: any, pageSize: number) => {
        pageData.pagination.pageSize = pageSize
      }
    }
    pageData.tags = computed(() => {
      return pageData.FlagEnterpriseType === 0 ? tags : tags.slice(0, 3).concat(tags.slice(4))
    })

    watch(
      () => props.pageSourceData,
      () => {
        nextTick(() => {
          pageData.spinning = false
        })
        const d = (props.pageSourceData || {}).IndustryComparisonData
        pageData.currIndustryComparisonData = d
        if (!d || Object.keys(d).length === 0) return
        pageData.data = handlerData(d, 'PerShareIndexData')
        pageData.FlagEnterpriseType = d[0].FlagEnterpriseType
        pageData.CompanyNumAndIndustryData = (props.pageSourceData || []).CompanyNumAndIndustryData
        pageData.defaultReportDate = (props.pageSourceData || {}).EndDate
        pageData.reportDate = pageData.defaultReportDate
      }
    )
    pageData.list = getList(pageData.activeTagVal)
    pageData.columns = getColumns(pageData.list)

    watch(
      () => pageData.columns,
      () => {
        const idx = pageData.columns.findIndex((item: any) => item.key === pageData.activelist)
        nextTick(() => {
          setTimeout(() => {
            mytable.value && mytable.value.clickTh(idx)
          }, 500)
        })
      },
      { deep: true, immediate: true }
    )
    watch(
      () => pageData.activeTagVal,
      () => {
        pageData.list = getList(pageData.activeTagVal)
        pageData.activelist = (pageData.list[0] || {}).val
        const d = pageData.currIndustryComparisonData
        pageData.data = handlerData(d, pageData.activeTagVal)
      },
      { deep: true }
    )
    watch(
      () => pageData.activelist,
      () => {
        pageData.tableKey++
        pageData.columns = getColumns(pageData.list)
        pageData.option = getOptions()
      }
    )
    watch(
      () => pageData.list,
      () => {
        pageData.tableKey++
        pageData.columns = getColumns(pageData.list)
      },
      { deep: true }
    )
    watch(
      () => pageData.data,
      () => {
        pageData.option = getOptions()
        pageData.total = pageData.data.length
      }
    )
    const route = useRoute()
    function getInfoF10IndustryEndDate() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        IndustryLevel: pageData.industryLevel
      }
      data.headers = {
        token: props.token
      }
      f10Api.getInfoF10IndustryEndDate(data).then((res: any) => {
        pageData.reportDatas = res.Data.EndDate || []
      })
    }
    function getList(activeTag: string) {
      return pageData.FlagEnterpriseType === 0 ? allList.ybqy[activeTag] : allList.jrqy[activeTag]
    }
    function getColumns(list: any) {
      pageData.pagination.current = 1
      pageData.pagination.pageSize = 10

      let colums: any = []
      ;(list || []).forEach((element: any) => {
        const type =
          ['每股收益_TTM', '每股净资产', '每股现金流量净额_TTM'].indexOf(element.name) > -1
            ? 'decimal4'
            : pageData.unit !== '%'
            ? 'peopleCountFixed2'
            : 'nocolorincrease'
        const tit = pageData.unit !== '%' ? `${element.name} (${pageData.unit})` : element.name
        colums.push({
          title: tit,
          dataIndex: element.val,
          key: element.val,
          slots: {
            customRender: type
          },
          width: element.val === 'TurnoverRateOfTotalAssetsTTM' ? '200px' : '',
          sorter: (a: any, b: any) => a[element.val] - b[element.val],
          sortDirections: ['descend', 'ascend']
          // defaultSortOrder: element.val === pageData.activelist ? 'descend' : false
        } as any)
      })
      colums = baseColumns.concat(colums)
      return colums
    }
    function handlerData(arr: any, name: string) {
      nextTick(() => {
        pageData.spinning = false
      })
      const result: any = []
      if ((arr || []).length < 1) return []
      arr.forEach((item: any, i: number) => {
        result.push(item[name])
        result[i].index = 'hydw' + i
        result[i].Inst = item.Inst
        result[i].Name = item.Name
      })
      return result
    }

    onMounted(() => {
      getInfoF10IndustryEndDate()
    })

    const color = globalsets.getColor()

    function formatNumber(name: string, num: any) {
      if (['每股收益_TTM', '每股净资产', '每股现金流量净额_TTM'].indexOf(name) > -1) {
        return parseFloat(num).toString() !== 'NaN' ? (num || 0).toFixed(4) : '—'
      } else {
        return globalsets.getNumber2(num)
      }
    }
    function getOptions() {
      const xAxisData: any = []
      const seriesData: any = []
      const scrollBarColor = props.theme === 'dark' ? '#888696' : '#D4D5D8'
      let currentIdx = 0
      if (!pageData.data || pageData.data.length === 0) {
        return null
      }
      const myData: any = pageData.data.slice(0)
      myData.sort((a: any, b: any) => {
        return b[pageData.activelist] - a[pageData.activelist]
      })
      myData.forEach((item: any, idx: number) => {
        xAxisData.push(item.Name)
        if (item.Inst === route.query.code) {
          seriesData.push({
            value: item[pageData.activelist],
            sort: seriesData.length + 1,
            itemStyle: {
              color: '#FF9300'
            }
          })
          currentIdx = idx
        } else {
          seriesData.push({ value: item[pageData.activelist], sort: seriesData.length + 1 })
        }
      })
      return {
        tooltip: {
          trigger: 'axis',
          formatter: function (param: any) {
            const params = param[0]
            const arr: any = pageData.list
            const obj = (arr || []).find((item: any) => {
              return item.val === pageData.activelist
            })
            return `<span class="tool-tip" style="background:${params.color};"></span> ${obj.name} ${formatNumber(obj.name, params.value)}${pageData.unit}`
          }
        },
        grid: {
          left: 20,
          right: 20,
          bottom: 40,
          top: 30,
          containLabel: true
        },
        dataZoom: [
          {
            type: 'slider',
            zoomLock: true,
            show: true,
            xAxisIndex: 0,
            bottom: 10,
            minValueSpan: 9,
            maxValueSpan: 9,
            height: 6,
            borderColor: 'rgba(0,0,0,0)',
            brushSelect: false,
            startValue: currentIdx,
            showDetail: false,
            dataBackground: {
              areaStyle: {
                opacity: 0
              },
              lineStyle: {
                opacity: 0
              }
            },
            fillerColor: scrollBarColor,
            handleSize: 4,
            handleIcon: 'circle',
            handleStyle: {
              opacity: 1,
              color: scrollBarColor,
              borderColor: scrollBarColor
            }
          }
        ],
        color: color,
        legend: {
          type: 'scroll'
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisPointer: {
            type: 'shadow'
          }
          // splitNumber: 10
        },
        yAxis: {
          type: 'value',
          name: '单位(' + pageData.unit + ')',
          boundaryGap: ['5%', '5%'],
          splitNumber: 3,
          splitLine: {
            lineStyle: {
              color: props.theme === 'dark' ? '#252A34' : '#DBDFE6'
            }
          }
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            barWidth: 34,
            itemStyle: {
              // normal: {

              opacity: 1
            },
            label: {
              formatter: function (params: any) {
                return `第${params.data.sort}名`
              },
              show: true,
              position: 'top',
              fontSize: '12',
              color: props.theme === 'dark' ? '#D7D7DF' : '#7d7d7d'
              // textStyle: {
              // }
            }
            // }
          }
        ]
      }
    }
    function checkTag(tag: any, idx: number) {
      pageData.unit = pageData.tags[idx].unit
      pageData.activeTagVal = tag
      pageData.activelist = pageData.list[0].val
    }
    function changList(val: any) {
      pageData.activelist = val
      // 控制图表数据更新
    }
    function changeReportDate(date: any) {
      pageData.reportDate = date
      getInfoF10IndustryPlace()
    }
    function changeGrade(grade: any) {
      pageData.industryLevel = grade
      getInfoF10IndustryPlace()
    }
    function getInfoF10IndustryPlace() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        EndDate: pageData.reportDate,
        IndustryLevel: pageData.industryLevel
      }
      data.headers = {
        token: props.token
      }
      f10Api.getInfoF10IndustryPlace(data).then((res: any) => {
        pageData.activeTagVal = tags[0].value
        pageData.currIndustryComparisonData = (res.Data || []).IndustryComparisonData || []
        pageData.data = handlerData(pageData.currIndustryComparisonData, pageData.activeTagVal)
        pageData.CompanyNumAndIndustryData = (res.Data || []).CompanyNumAndIndustryData
      })
    }
    return {
      ...toRefs(pageData),
      checkTag,
      changList,
      changeReportDate,
      changeGrade,
      mytable
    }
  }
})
